<!-- <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate class="user">
    <div class="form-group">
        <input type="password" formControlName="newPassword" class="form-control form-control-user"
               placeholder="Mật khẩu mới"
               [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }" />
        <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
            <div *ngIf="f.newPassword.errors.required">Mật khẩu mới là bắt buộc</div>
            <div *ngIf="f.newPassword.errors.minlength">Mật khẩu phải có ít nhất 6 ký tự</div>
        </div>
    </div>

    <div class="form-group">
        <input type="password" formControlName="confirmPassword" class="form-control form-control-user"
               placeholder="Xác nhận mật khẩu mới"
               [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
        <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
            <div *ngIf="f.confirmPassword.errors.required">Xác nhận mật khẩu là bắt buộc</div>
            <div *ngIf="f.confirmPassword.errors.mustMatch">Mật khẩu không khớp</div>
        </div>
    </div>

    <button type="submit" class="btn btn-primary btn-user btn-block">
        Đặt lại mật khẩu
    </button>

    <hr>
    <div class="text-center">
        <a class="small" routerLink="/login">Quay lại đăng nhập</a>
    </div>
</form> -->

<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
        <label for="token">Mã đặt lại</label>
        <input type="text" class="form-control" id="token" formControlName="token" required>
    </div>

    <div class="form-group">
        <label for="newPassword">Mật khẩu mới</label>
        <input type="password" class="form-control" id="newPassword" formControlName="newPassword" required>
    </div>

    <div class="form-group">
        <label for="confirmPassword">Xác nhận mật khẩu</label>
        <input type="password" class="form-control" id="confirmPassword" formControlName="confirmPassword" required>
    </div>

    <button type="submit" class="btn btn-primary">Đặt lại mật khẩu</button>
</form>